import type { AxiosResponse } from 'axios';
import { HttpCodeStatus, EXPIRED_OR_SUSPENDED_ACCOUNT_MESSAGE } from '../query/HttpCodeStatus';

export const isAccountExpiredOrSuspended = ({ data, status }: AxiosResponse) =>
  data?.message === EXPIRED_OR_SUSPENDED_ACCOUNT_MESSAGE && status === HttpCodeStatus.FORBIDDEN;
